(function () {
  if (window.__ekInit) return;
  window.__ekInit = true;

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function initDates(root) {
    root.querySelectorAll('[data-ek-date]').forEach(function (el) {
      var spec = el.getAttribute('data-ek-date');
      var today = new Date();
      if (spec === 'today') { el.textContent = fmt(today); return; }
      var parts = spec.split('-').map(function (n) { return parseInt(n, 10); });
      if (parts.length === 2) {
        el.textContent = fmt(addBusinessDays(today, parts[0])) + ' – ' + fmt(addBusinessDays(today, parts[1]));
      } else {
        el.textContent = fmt(addBusinessDays(today, parts[0]));
      }
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-ek-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-ek-main]');
      g.querySelectorAll('[data-ek-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          main.src = t.getAttribute('data-full');
          main.alt = t.querySelector('img').alt;
          g.querySelectorAll('[data-ek-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('.ek-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px 15% 0px' });
    setTimeout(function () { root.querySelectorAll('.ek-reveal').forEach(function (e) { e.classList.add('is-in'); }); }, 2500);
    els.forEach(function (e) { io.observe(e); });
  }

  // Preload the Printify personalizer so the modal opens ready instead of blank
  function pzUrl(inst, pid) {
    var s = 'https://personalize.at/iframe/' + encodeURIComponent(pid), l = [];
    var sku = inst.getCurrentSku && inst.getCurrentSku();
    if (sku) l.push('sku=' + encodeURIComponent(sku));
    var o = inst.getSelectedOptions ? inst.getSelectedOptions() : { optionNames: [], optionValues: [] };
    o.optionNames.forEach(function (n, i) { var v = o.optionValues[i]; if (n && v) l.push('options[' + encodeURIComponent(n) + ']=' + encodeURIComponent(v)); });
    l.push('sales_channel=shopify');
    return s + '?' + l.join('&');
  }

  function initPersonalizer() {
    var c = document.querySelector('.personalize-container[data-block-id]');
    if (!c) return true;
    var id = c.dataset.blockId, inst = window['personalize_' + id], pid = c.dataset.printifyProductId;
    var m = document.getElementById('personalizeModal-' + id), fr = document.getElementById('personalizeIframe-' + id);
    if (!inst || !inst.openPersonalizeModal || !m || !fr || !pid) return false;
    if (!inst.hasMetafields || inst.ekPre) return true;
    inst.ekPre = true;

    // Moving an iframe in the DOM reloads it, so move the modal to <body> before preloading
    if (m.parentNode !== document.body) document.body.appendChild(m);
    var box = fr.parentNode;
    box.style.position = 'relative';
    var ld = document.createElement('div');
    ld.className = 'ek-pz-loading';
    ld.innerHTML = '<span></span>Loading your ornament preview…';
    box.appendChild(ld);
    var st = document.createElement('style');
    st.textContent = '.ek-pz-loading{position:absolute;left:0;right:0;bottom:0;top:52px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;background:#fbf8f2;color:#2e2a22;font-size:16px;text-align:center;padding:24px;z-index:2}.ek-pz-loading span{width:34px;height:34px;border:3px solid #e8dccb;border-top-color:#a8232c;border-radius:50%;animation:ekspin .8s linear infinite}.ek-pz-ready .ek-pz-loading{display:none}@keyframes ekspin{to{transform:rotate(360deg)}}' +
      '.ek-pz-pre{display:block!important;visibility:hidden!important;pointer-events:none!important}';
    document.head.appendChild(st);

    var isOpen = false;
    fr.addEventListener('load', function () {
      if (fr.getAttribute('src')) setTimeout(function () { m.classList.add('ek-pz-ready'); }, 400);
    });
    // Load it in a real-size but invisible modal so the editor lays out correctly
    function preload() {
      if (isOpen) return;
      m.classList.remove('ek-pz-ready');
      m.classList.add('ek-pz-pre');
      fr.src = pzUrl(inst, pid);
    }

    var open = inst.openPersonalizeModal, close = inst.closePersonalizeModal;
    inst.openPersonalizeModal = function (p) {
      isOpen = true;
      m.classList.remove('ek-pz-pre');
      if (fr.getAttribute('src') === pzUrl(inst, p)) {
        m.style.display = 'block';
        document.body.style.overflow = 'hidden';
        return;
      }
      m.classList.remove('ek-pz-ready');
      return open.apply(inst, arguments);
    };
    inst.closePersonalizeModal = function () {
      var r = close.apply(inst, arguments);
      isOpen = false;
      setTimeout(preload, 800);
      return r;
    };
    preload();
    return true;
  }

  function init(root) { initDates(root); initGallery(root); initReveal(root); }
  if (document.readyState !== 'loading') init(document); else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Start as soon as the Printify block has initialised (retry for up to ~15s)
  var pzTries = 0;
  function tryPz() { if (!initPersonalizer() && ++pzTries < 50) setTimeout(tryPz, 300); }
  if (document.readyState !== 'loading') setTimeout(tryPz, 300); else document.addEventListener('DOMContentLoaded', function () { setTimeout(tryPz, 300); });
})();
